
import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { useLanguage } from '@/contexts/LanguageContext';
import { basePath } from '@/integrations/supabase/client';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const { toast } = useToast();
  const { t } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      toast({
        title: t('auth.required'),
        description: t('auth.requiredDesc'),
        variant: "destructive",
      });

      // Log the origination URL with baabaa.app reference when appropriate
      const originUrl = typeof window !== 'undefined' && window.location.hostname.includes('baabaa.app')
        ? `https://baabaa.app${basePath}${location.pathname}`
        : `${window.location.origin}${basePath}${location.pathname}`;
      
      console.log("Auth redirect from:", originUrl);
    }
  }, [loading, user, toast, t, location.pathname]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">
      <p>{t('common.loading')}</p>
    </div>;
  }

  if (!user) {
    // Save the current location to redirect back after login
    // Don't use basePath here as react-router-dom already has the basename set
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
